<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">


        <h1 class="title-default">Financas</h1>
        <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Financas</span>! Aqui você encontra
            o seu financeiro.</p>
        <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
    </div>
</div>